import { extendTheme, type ThemeConfig } from "@chakra-ui/react";

const config: ThemeConfig = {
  initialColorMode: "light",
  useSystemColorMode: false,
};

const theme = extendTheme({
  config,
  fonts: {
    heading: `"Atkinson Hyperlegible Next", -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif`,
    body: `"Atkinson Hyperlegible Next", -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif`,
  },
  colors: {
    primary: "purple",
  },
  styles: {
    global: {
      "html, body": {
        fontFamily: "body",
        bg: "gray.50",
        color: "gray.900",
      },
      a: {
        color: "purple.600",
        _hover: {
          textDecoration: "underline",
        },
      },
    },
  },
  components: {
    Heading: {
      baseStyle: {
        fontWeight: "bold",
      },
    },
    Button: {
      baseStyle: {
        fontWeight: "semibold",
      },
    },
    Link: {
      baseStyle: {
        _focus: {
          boxShadow: "outline",
        },
      },
    },
  },
});

export default theme;
